import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UnSavedChangesRouteGuard } from 'src/app/shared/routeguards/unsavedChangesRouteGuard';

import { KioskConfigurationGridComponent  } from './kiosk-configuration-grid/kiosk-configuration-grid.component';
import { KioskConfigurationSettingsComponent } from './kiosk-configuration-settings/kiosk-configuration-settings.component';

const routes: Routes = [ 
  { path: 'kiosk-grid', component: KioskConfigurationGridComponent },
  { path: 'kiosk-settings/:locationCode', component: KioskConfigurationSettingsComponent, canDeactivate: [UnSavedChangesRouteGuard] },
  { path: '',  redirectTo: 'kiosk-grid', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KioskRoutingModule { }
